import { Controller } from "@hotwired/stimulus";
import { Calendar } from "vanilla-calendar-pro";

export default class extends Controller {
  connect() {
    const input = this.element; // Hidden input field, e.g., from simple_form
    const calendarContainer = document.createElement("div");
    calendarContainer.className = "calendar-wrapper";

    // Insert calendar container after the hidden input
    input.after(calendarContainer);

    // Initialize the calendar
    const calendar = new Calendar(calendarContainer, {
      locale: "de",
      selectedDates: [input.value],
      dateMin: new Date().toISOString().slice(0, 10), // Disable past dates
      onClickDate: (self) => this.updateInputValue(input, self),
      onInit: (self) => this.updateInputValue(input, self),
    });

    calendar.init();
  }

  updateInputValue(input, calendarInstance) {
    const date = calendarInstance.context.selectedDates[0]; // "YYYY-MM-DD"

    input.value = date;
  }
}
